import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CtButtonModule, CtModelModule} from '@ctsolution/ct-framework';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyButtonModule} from "@angular/material/legacy-button";
import {MatLegacyMenuModule} from "@angular/material/legacy-menu";
import { LeadDocumentsComponent } from './lead-documents.component';
import { LeadDocumentsService } from './lead-documents.service';
import { LeadDocumentsWizardModule } from './lead-documents-wizard/lead-documents-wizard.module';
import { WorkOrderDocumentDeleteDialogModule } from '../../work-order/work-order-edit/work-order-default-edit/work-order-documents/work-order-document-delete-dialog/work-order-document-delete-dialog.module';
import { WorkOrderDocumentsService } from '../../work-order/work-order-edit/work-order-default-edit/work-order-documents/work-order-documents.service';

@NgModule({
  imports: [
    CommonModule,
    LeadDocumentsWizardModule,
    WorkOrderDocumentDeleteDialogModule,
    CtButtonModule,
    CtModelModule,
    MatIconModule,
    MatLegacyButtonModule,
    MatLegacyMenuModule,
  ],
  declarations: [LeadDocumentsComponent],
  exports : [LeadDocumentsComponent],
  providers : [LeadDocumentsService, WorkOrderDocumentsService]
})
export class LeadDocumentsModule { }
